import { useState, useCallback } from 'react';
import { ZERO } from 'src/utilities/constants';
import axios from 'axios';
import {
  FAILED_PRESIGNED_URL,
  FAILED_TO_DOWNLOAD,
  FILE_NAME_CHAR_LIMIT,
  INVALID_PASSCODE,
  SERVER_GET_PRESIGNED_ENDPOINT,
  UNAUTHORIZED_STATUS_CODE
} from './constants';
import { getLoginDetails } from 'src/utilities/checkCookie';

export const usePresignedUrl = (initialState) => {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [presignedUrl, setPresignedUrl] = useState('');
  const [filename, setFilename] = useState('');
  /*
      TODO: remove GET_PRESIGNED_URL its needed for local testin only.
      */
  const GET_PRESIGNED_URL = 'https://airavatlab.devzinier.net/getPresignedUrl';

  const isDev = (orgId) => orgId === 'local';

  const getPresignedUrl = async (docId, passcode) => {
    try {
      const { orgId: serverOrgId, envLab } = await getLoginDetails();

      /*
      TODO: remove isDev() checks its for local testing.
      */
      const reqUrl = isDev(serverOrgId)
        ? GET_PRESIGNED_URL
        : `${envLab}${SERVER_GET_PRESIGNED_ENDPOINT}`;

      const orgId = isDev(serverOrgId) ? 'jed15' : serverOrgId;

      const { data } = await axios.post(
        reqUrl,
        { orgId, docId, code: passcode },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      );

      if (!data?.status || !data?.data?.length) {
        setError(FAILED_PRESIGNED_URL);
        throw new Error(FAILED_PRESIGNED_URL);
      }

      const presignedUrl = data.data[ZERO].presignedUrl;
      setPresignedUrl(presignedUrl);
      setFilenameFromPresignedUrl(presignedUrl);
    } catch (error) {
      const errorMessage =
        error.response?.status === UNAUTHORIZED_STATUS_CODE
          ? INVALID_PASSCODE
          : FAILED_TO_DOWNLOAD;
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const submitPasscode = useCallback(
    async (docId, passcode) => {
      setIsLoading(true);
      setError('');
      getPresignedUrl(docId, passcode);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [initialState]
  );

  const setFilenameFromPresignedUrl = (presignedUrl) => {
    const parsedUrl = new URL(presignedUrl);
    const fileName = parsedUrl.pathname.split('/').pop();
    const fileExtension = fileName.split('.').pop();
    const fileNameWithoutExtension = fileName.slice(
      ZERO,
      fileName.lastIndexOf('.')
    );

    let trimmedFileName;
    if (fileNameWithoutExtension.length > FILE_NAME_CHAR_LIMIT) {
      trimmedFileName = `${fileNameWithoutExtension.slice(
        ZERO,
        FILE_NAME_CHAR_LIMIT
      )}...`;
    } else {
      trimmedFileName = fileNameWithoutExtension;
    }

    const finalFileName = `${trimmedFileName}.${fileExtension}`;
    setFilename(finalFileName);
  };

  return { submitPasscode, error, isLoading, presignedUrl, filename };
};
